import React from "react";

export const Failure = () => {
  return (
    <div>
      <div className="carrito">
        <h1 className="title">To compra ha fallado. Intentalo de nuevo. </h1>
      </div>
    </div>
  );
};
